export function getToken() {
  try {
    return localStorage.getItem("nutricao-animal-usuario-token");
  } catch (error) {
    return null;
  }
}

export function formatMoeda(value, numDec = 2) {
  try {
    return value.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: numDec,
    });
  } catch (error) {
    return 0;
  }
}

export function formatPercentual(value, numDec = 2) {
  try {
    return Number(value / 100).toLocaleString("pt-br", {
      style: "percent",
      minimumFractionDigits: numDec,
    });
  } catch (error) {
    return 0;
  }
}

export function formatarNumeroDec(value) {
  try {
    if (value.trim() == "") {
      return 0;
    }
    if (value.includes(",")) return value.replace(",", ".");

    return value;
  } catch (error) {
    return 0;
  }
}

export function getUrlRelatorio() {
  return process.env.NODE_ENV == "development"
    ? "http://192.168.1.187/app/impressao"
    : "https://www.coasul.com.br/nutricao-animal/impressao";
}

export default {
  getToken,
  formatMoeda,
  formatPercentual,
  formatarNumeroDec,
};
